import { InjectionToken } from '@angular/core';
import { CellData } from '../models';

export const CELL_DATA = new InjectionToken<CellData<unknown, unknown>>('Cell Data');
